import { render, staticRenderFns } from "./DestinationReferences.vue?vue&type=template&id=69fc644a&scoped=true&"
import script from "./DestinationReferences.vue?vue&type=script&lang=js&"
export * from "./DestinationReferences.vue?vue&type=script&lang=js&"
import style0 from "./DestinationReferences.vue?vue&type=style&index=0&id=69fc644a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fc644a",
  null
  
)

export default component.exports